import { useQueryClient } from '@tanstack/react-query';
import type { EventParticipantFeedback } from 'models';
import { useMutation } from 'query';
import { createNodeEventFeedback } from '../../services';
import { getNodeEventsFeatureQueryKey } from '../keys';

export const useCreateNodeEventFeedback = () => {
  const queryClient = useQueryClient();

  return useMutation<undefined, { data: EventParticipantFeedback; eventId: string; viewerId: string }>({
    async mutationFn({ data, eventId, viewerId }) {
      const response = await createNodeEventFeedback({
        body: createRequestData(data),
        routeParams: { eventId, participantId: viewerId },
      });

      return response.data;
    },
    async onSettled(_) {
      await queryClient.invalidateQueries({
        queryKey: getNodeEventsFeatureQueryKey(),
      });
    },
  });
};

const createRequestData = (data: EventParticipantFeedback) => ({
  providerRating: data.providerRating,
  providerText: data.providerText,
  serviceRating: data.serviceRating,
  serviceText: data.serviceText,
  videoRating: data.videoRating,
  videoText: data.videoText,
});
